import { initCursor } from "./video-cursor";
import "plyr/dist/plyr.css";
import Plyr from "plyr";

interface VideoController {
  toggle: () => void;
  destroy: () => void;
}

function createVideoController(video: HTMLElement, player: HTMLElement) {
  let isPlaying: boolean = false;
  let plyrInstance: Plyr | null = null;

  const cursorFactory = initCursor();
  let cursorInstance = cursorFactory ? cursorFactory() : null;

  if (cursorInstance !== null) {
    cursorInstance.init();
  }

  // Создаем плеер только когда нужно
  const initializePlayer = () => {
    if (plyrInstance === null) {
      plyrInstance = new Plyr(video, {
        controls: ["play", "progress", "current-time", "mute", "volume", "fullscreen", "pip"],
      });
    }

    return plyrInstance;
  };

  const hiddenVideoPlayer = () => {
    if (
      window.matchMedia("(max-width: 768px)").matches ||
      window.matchMedia("(max-width: 1199px) and (min-width: 769px) and (pointer: coarse)").matches
    ) {
      player.style.display = player.style.display === "none" ? "block" : "none";
    } else {
      player.style.display = "none";
    }
  };

  const togglePlay = () => {
    if (isPlaying) {
      if (plyrInstance) {
        plyrInstance.pause();
      }
    } else {
      if (cursorInstance !== null) {
        cursorInstance.destroy();
        cursorInstance = null;
      }

      hiddenVideoPlayer();
      initializePlayer().play();
    }

    isPlaying = !isPlaying;
  };

  video.addEventListener("click", togglePlay);

  return {
    toggle: togglePlay,
    destroy: () => {
      if (plyrInstance) {
        plyrInstance.destroy();
        plyrInstance = null;
      }
    },
  };
}

export function initVideo() {
  const video = document.querySelector<HTMLElement>(".control__video-instance");
  const videoPlayer = document.querySelector<HTMLElement>(".control__play");

  if (!video || !videoPlayer) return;

  createVideoController(video, videoPlayer);
}
